import React from 'react';
import AboutUs from '../components/AboutUs';

const AboutPage = () => {
  return (
    <div>
      <AboutUs />
    </div>
  );
};

export default AboutPage;
